<div class="customers" *ngIf="!showApelacion">
    <div class="card">
        <div class="card-body" style="padding: 20px;">

            <div class="row">
                <div class="col-sm-6" style="text-align: right;">
                    <div class="image-title">
                        <img src="../../../../../assets/icons/03-validacion@2x.png" alt="avatar" class="title-pic">
                    </div>
                </div>
                <div class="col-sm-6" style="text-align: right;">
                    <p class="estado">Estado Validación</p>
                    <p class="estado-data">No Disponible</p>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <p class="titulo-etapa">Etapa 3: Validación</p>
                    <p class="texto-etapa">Esta sección estará disponible de acuerdo a la etapa del proceso que se encuentre transitando su unidad educativa.</p>
                    <p class="alerta">Para revisar el instructivo de uso de Zoom y prepárese para la entrevista de validación, presione <a [routerLink]="" (click)="verVideo('instructivo')"><b
                        class="alerta" style="text-decoration: underline; cursor: pointer;padding: 0px;">acá</b>.</a></p>


                    <div class="content-numbers">
                        <ul class="numbers">
                            <li [ngClass]="{'selected':one === true}" (click)="tab1()">
                                <p class="number">1</p>
                                <p class="title">Agenda</p>
                            </li>
                            <li *ngIf="!activaPaso2" [ngClass]="{'selected':two === true}" class="disabled">
                                <p class="number">2</p>
                                <p class="title">Entrevista</p>
                            </li>
                            <li *ngIf="activaPaso2" [ngClass]="{'selected':two === true}" (click)="tab2()">
                                <p class="number">2</p>
                                <p class="title">Entrevista</p>
                            </li>

                            
                            <li *ngIf="!jardinPeriodoInforme.liberadoInformeResultados" [ngClass]="{'selected':three === true}" class="disabled" >
                                <!-- <li [ngClass]="{'selected':three === true}" (click)="tab3()"> -->
                                <p class="number">3</p>
                                <p class="title">Informes</p>
                            </li>
                            <li *ngIf="jardinPeriodoInforme.liberadoInformeResultados" [ngClass]="{'selected':three === true}" (click)="tab3()" >
                                <!-- <li [ngClass]="{'selected':three === true}" (click)="tab3()"> -->
                                <p class="number">3</p>
                                <p class="title">Informes</p>
                            </li>
                        </ul>
                        <p class="line"><span>linea</span></p>
                    </div>

                    <div class="stepOne" *ngIf="one">
                        <div class="row">
                            <div class="col-md-2">
                                <img src="../../../../../assets/icons/404-wip_1.png" class="calendario">
                            </div>
                            <div class="col-md-10">
                                <div class="row">
                                    <div class="col-md-12">
                                        <p>La validación para su Unidad Educativa se encuentra <strong>agendada</strong> para:</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="card-gris jornada">
                                            <p class="title">Jornada 1</p>
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <label for="diaUno" class="dia">Día:</label>
                                                    <input type="text" placeholder="{{jornada1FechaHoraView | date: 'dd-MM-yyyy' }}">
                                                </div>
                                                <div class="col-md-6">
                                                    <label for="horaUno" class="hora">Hora:</label>
                                                    <input type="text" placeholder="{{jornada1FechaHoraView | date: 'HH:mm' : '-0'}}">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="card-gris jornada">
                                            <p class="title">Jornada 2</p>
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <label for="diaDos" class="dia">Día:</label>
                                                    <input type="text" placeholder="{{jornada2FechaHoraView | date: 'dd-MM-yyyy'}}">
                                                </div>
                                                <div class="col-md-6">
                                                    <label for="horaDos" class="hora">Hora:</label>
                                                    <input type="text" placeholder="{{jornada2FechaHoraView | date: 'HH:mm' : '-0'}}">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <p style="margin-top: 4px;">El día de la entrevista, acceda al paso 2 donde encontrará los documentos y el enlace de la reunión.</p>
                                    </div>
                                </div>
                            </div>
                        </div> 
                    </div>
                    <div class="stepTwo" *ngIf="two">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card-gris entrevista">
                                    <p class="tituloSeccion entrevistaValidacion">Entrevista de Validación</p>
                                    <p class="estado disponible">Disponible</p>
                                    <div class="fecha">
                                        <p class="titulo">Fecha:</p>
                                        <p class="resultado">{{jornada1FechaHoraView | date: 'dd-MM-yyyy' }}</p>
                                    </div>
                                    <a href="{{linkEntrevista}}" target="_blank"><button>Acceder</button></a>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card-gris entrevista">
                                    <p class="tituloSeccion cartaPresentacion">Carta de Presentacion</p>
                                    <p class="estado disponible">Disponible</p>
                                    <div class="fecha">
                                        <p class="titulo">Fecha:</p>
                                        <p class="resultado">{{jornada2FechaHoraView | date: 'dd-MM-yyyy' }}</p>
                                    </div>
                                    <button (click)="mostrarCartaPresentacion()">Acceder</button>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card-gris entrevista">
                                    <p class="tituloSeccion actaValidacion">Acta de Validación</p>
                                    <p class="{{classEstado}}">{{proceso}}</p>
                                    <div class="fecha">
                                        <p class="titulo">Fecha:</p>
                                        <p class="resultado">{{fechaActaValidacion | date: 'dd-MM-yyyy' }}</p>
                                    </div>
                                    <button (click)="modalActaView()" [disabled]="!actaIniciada">{{actaFirmada}}</button>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card-gris entrevista">
                                    <p class="tituloSeccion pautaEvaluacion">Pauta de Evaluación (Confidencial)</p>
                                    <p class="{{estadoClase}}">{{estadoEvaluacion}}</p>
                                    <div class="fecha">
                                       <p class="titulo">Fecha:</p>
                                        <p class="resultado">{{fechaEvaluacion | date:'dd/MM/yyyy'}}</p>
                                    </div>
                                    <button (click)="modalEvaluacionConfidencialView()" >{{estadoEvaluacionButton}}</button>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <p style="margin-top: 4px;">En los próximos días podrá acceder al informe de resultados en el paso 3.</p>
                            </div>
                        </div>
                    </div>
                    <div class="stepThree" *ngIf="three">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card-gris entrevista">
                                    <p class="tituloSeccion entrevistaValidacion">Informe de Resultados</p>
                                    <p class="estado disponible">Disponible</p>
                                    <div class="fecha">
                                        <p class="titulo">Fecha de Lectura:</p>
                                        <p class="resultado">{{jardinPeriodoInforme.fechaVistaInformeRestultados | date: 'dd-MM-yyyy':'-0' }}</p>
                                    </div>
                                    <button (click)="verInformeResultados()">VER</button>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card-gris entrevista">
                                    <p class="tituloSeccion cartaPresentacion">Apelación</p>
                                    <p class="estado disponible" *ngIf="!jardinPeriodoInforme.envioApeliacion" envioApeliacion>No iniciada</p>
                                    <p class="estado disponible" *ngIf="jardinPeriodoInforme.envioApeliacion">Enviada</p>
                                    <div class="fecha">
                                        <p class="titulo">Plazo:</p>
                                        <p class="resultado">{{jardinPeriodoInforme.fechaLimiteApelacion | date: 'dd-MM-yyyy':'-0' }}</p>
                                    </div>
                                    <button (click)="showApelacionJardin()" [disabled]="jardinPeriodoInforme.fechaVistaInformeRestultados === null || jardinPeriodoInforme.fechaInformeRetroalimentacion != null" *ngIf="jardinPeriodoInforme.envioApeliacion === null || !jardinPeriodoInforme.envioApeliacion " >APELAR</button>
                                    <button (click)="showApelacionJardin()" [disabled]="jardinPeriodoInforme.fechaVistaInformeRestultados === null" *ngIf="jardinPeriodoInforme.envioApeliacion">VER APELACIÓN</button>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card-gris entrevista">
                                    <p class="tituloSeccion actaValidacion">Informe de Retroalimentación</p>
                                    <p class="{{classEstado}}" *ngIf="jardinPeriodoInforme.fechaInformeRetroalimentacion === null" >No Disponible</p>
                                    <p class="{{classEstado}}" *ngIf="jardinPeriodoInforme.fechaInformeRetroalimentacion != null">Disponible</p>
                                    <div class="fecha">
                                        <p class="titulo">Fecha:</p>
                                        <p class="resultado">{{jardinPeriodoInforme.fechaInformeRetroalimentacion | date: 'dd-MM-yyyy':'-0' }}</p>
                                    </div>
                                    <button [disabled]="jardinPeriodoInforme.fechaInformeRetroalimentacion === null" (click)="showInformeRetroalimentacion()" >VER</button>
                                </div>
                            </div>
                        </div>
                       
                    </div>

                    
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="showApelacion">
    <app-apelacion-jardin></app-apelacion-jardin>
</div>
